import React from 'react';
import PropTypes from 'prop-types';
import Combobox from 'infrastructure/js/components/controls/Combobox/combobox';
import Parse from 'infrastructure/js/components/controls/controlsParse';
import Format from 'infrastructure/js/components/controls/controlsFormat';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import Label from 'infrastructure/js/components/Label/label.js';
import cn from 'classnames';
import withPortal from 'infrastructure/js/components/HOCs/withPortal/withPortal';

import './toolCategoryOperationListItem.scss';

const ComboboxPortal = withPortal(Combobox);

export default class ToolCategoryOperationListItem extends React.PureComponent {

  onOperationChangeCallback = (value, oldValue) => {
    this.props.onChangeCallback?.(value, oldValue, this.props.index);
  };

  getComponentToRender = (props) => {
    return props && props.data ? <Label text={props.data.label} /> : null;
  };

  render() {
    const { options, name  } = this.props;

    return (
      <div className={cn('tool-category-operation-list-item')}>
          <ComboboxPortal
            id={name + '.[operationName]'}
            name={name + '.[operationName]'}
            options={options}
            parse={Parse.comboValueOnly()}
            format={Format.findOptionByValue(options)}
            onChangeCallback={this.onOperationChangeCallback}
            className=""
            validate={Validation.required}
            singleValueRenderer={this.getComponentToRender}
            optionRenderer={this.getComponentToRender}
          />
      </div>
    );
  }
}

ToolCategoryOperationListItem.defaultProps = {
  options: [],
};

ToolCategoryOperationListItem.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
};
